import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Truck, Package, MapPin, Phone, Navigation, Clock, Search, Filter, CheckCircle, AlertCircle } from 'lucide-react';
export function LogisticsShipments() {
  const shipments = [{
    id: 'PO-2023-001',
    trackingNumber: 'JNE88291002',
    cooperative: 'Koperasi Maju Jaya',
    destination: 'Bogor, Jawa Barat',
    address: 'Jl. Raya Desa No. 123, RT 01/RW 02',
    items: 32,
    weight: 160,
    status: 'in_transit',
    statusLabel: 'Dalam Pengiriman',
    currentLocation: 'Gudang Transit Bogor',
    eta: 'Besok, 14:00 WIB',
    progress: 75,
    driver: 'Ahmad Yani',
    driverPhone: '+62 812-9999-8888',
    vehicle: 'B 1234 XYZ',
    pickupTime: '11 Okt 2023, 08:00',
    estimatedDelivery: '12 Okt 2023, 14:00'
  }, {
    id: 'PO-2023-004',
    trackingNumber: 'JNE88291005',
    cooperative: 'Koperasi Sejahtera',
    destination: 'Bandung, Jawa Barat',
    address: 'Jl. Soekarno Hatta No. 456',
    items: 28,
    weight: 140,
    status: 'in_transit',
    statusLabel: 'Dalam Pengiriman',
    currentLocation: 'Dalam Perjalanan',
    eta: 'Hari ini, 16:00 WIB',
    progress: 60,
    driver: 'Budi Santoso',
    driverPhone: '+62 813-8888-7777',
    vehicle: 'B 5678 ABC',
    pickupTime: '11 Okt 2023, 09:00',
    estimatedDelivery: '11 Okt 2023, 16:00'
  }, {
    id: 'PO-2023-006',
    trackingNumber: 'JNE88291007',
    cooperative: 'Koperasi Makmur',
    destination: 'Depok, Jawa Barat',
    address: 'Jl. Margonda Raya No. 789',
    items: 45,
    weight: 225,
    status: 'ready',
    statusLabel: 'Siap Pickup',
    currentLocation: 'Gudang Transit Bogor',
    eta: 'Menunggu pickup',
    progress: 0,
    driver: 'Belum ditugaskan',
    driverPhone: '-',
    vehicle: '-',
    pickupTime: 'Belum dijadwalkan',
    estimatedDelivery: '-'
  }, {
    id: 'PO-2023-002',
    trackingNumber: 'JNE88291003',
    cooperative: 'Koperasi Mandiri',
    destination: 'Jakarta Selatan',
    address: 'Jl. TB Simatupang No. 321',
    items: 18,
    weight: 90,
    status: 'delivered',
    statusLabel: 'Terkirim',
    currentLocation: 'Delivered',
    eta: 'Selesai',
    progress: 100,
    driver: 'Joko Widodo',
    driverPhone: '+62 814-7777-6666',
    vehicle: 'B 9012 DEF',
    pickupTime: '9 Okt 2023, 08:00',
    estimatedDelivery: '9 Okt 2023, 14:30'
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'in_transit':
        return 'warning';
      case 'ready':
        return 'neutral';
      case 'delivered':
        return 'success';
      default:
        return 'neutral';
    }
  };
  return <div className="space-y-6" data-id="element-2598">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-2599">
        <div data-id="element-2600">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-2601">
            Active Shipments
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-2602">
            Kelola dan monitor semua pengiriman aktif
          </p>
        </div>
        <div className="flex gap-2" data-id="element-2603">
          <Button variant="outline" size="sm" icon={<Filter className="w-4 h-4" data-id="element-2605" />} data-id="element-2604">
            Filter
          </Button>
        </div>
      </div>

      {/* Search & Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-2606">
        <Card className="col-span-1 p-4" data-id="element-2607">
          <div className="relative" data-id="element-2608">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-2609" />
            <input type="text" placeholder="Cari tracking number..." className="w-full pl-10 pr-4 py-2 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-2610" />
          </div>
        </Card>

        <Card className="p-4 bg-blue-50 border-blue-200" data-id="element-2611">
          <div className="flex items-center justify-between" data-id="element-2612">
            <div data-id="element-2613">
              <p className="text-xs text-blue-700 mb-1" data-id="element-2614">In Transit</p>
              <p className="text-2xl font-bold text-blue-900" data-id="element-2615">2</p>
            </div>
            <Truck className="w-8 h-8 text-blue-600" data-id="element-2616" />
          </div>
        </Card>

        <Card className="p-4 bg-amber-50 border-amber-200" data-id="element-2617">
          <div className="flex items-center justify-between" data-id="element-2618">
            <div data-id="element-2619">
              <p className="text-xs text-amber-700 mb-1" data-id="element-2620">Ready Pickup</p>
              <p className="text-2xl font-bold text-amber-900" data-id="element-2621">1</p>
            </div>
            <Package className="w-8 h-8 text-amber-600" data-id="element-2622" />
          </div>
        </Card>

        <Card className="p-4 bg-green-50 border-green-200" data-id="element-2623">
          <div className="flex items-center justify-between" data-id="element-2624">
            <div data-id="element-2625">
              <p className="text-xs text-green-700 mb-1" data-id="element-2626">Delivered</p>
              <p className="text-2xl font-bold text-green-900" data-id="element-2627">1</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" data-id="element-2628" />
          </div>
        </Card>
      </div>

      {/* Shipments List */}
      <div className="space-y-4" data-id="element-2629">
        {shipments.map(shipment => <Card key={shipment.id} className="p-6" data-id="element-2630">
            <div className="flex items-start gap-6" data-id="element-2631">
              {/* Status Icon */}
              <div className="flex-shrink-0" data-id="element-2632">
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center shadow-lg ${shipment.status === 'in_transit' ? 'bg-gradient-to-br from-blue-500 to-blue-600' : shipment.status === 'ready' ? 'bg-gradient-to-br from-amber-500 to-amber-600' : 'bg-gradient-to-br from-green-500 to-green-600'}`} data-id="element-2633">
                  {shipment.status === 'delivered' ? <CheckCircle className="w-8 h-8 text-white" data-id="element-2634" /> : <Truck className="w-8 h-8 text-white" data-id="element-2635" />}
                </div>
              </div>

              {/* Shipment Info */}
              <div className="flex-1 min-w-0" data-id="element-2636">
                <div className="flex items-start justify-between mb-3" data-id="element-2637">
                  <div data-id="element-2638">
                    <div className="flex items-center gap-3 mb-2" data-id="element-2639">
                      <h4 className="text-xl font-bold text-slate-900" data-id="element-2640">
                        {shipment.id}
                      </h4>
                      <Badge variant={getStatusColor(shipment.status)} data-id="element-2641">
                        {shipment.statusLabel}
                      </Badge>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-2642">
                      <span className="font-mono" data-id="element-2643">
                        {shipment.trackingNumber}
                      </span>
                      <span className="text-slate-400" data-id="element-2644">•</span>
                      <span data-id="element-2645">{shipment.cooperative}</span>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-2646">
                    <p className="text-sm text-slate-600 mb-1" data-id="element-2647">ETA</p>
                    <p className="text-lg font-bold text-blue-600" data-id="element-2648">
                      {shipment.eta}
                    </p>
                  </div>
                </div>

                {/* Progress Bar */}
                {shipment.status !== 'delivered' && shipment.status !== 'ready' && <div className="mb-4" data-id="element-2649">
                      <div className="flex justify-between items-center mb-2" data-id="element-2650">
                        <div className="flex items-center gap-2" data-id="element-2651">
                          <MapPin className="w-4 h-4 text-blue-600" data-id="element-2652" />
                          <span className="text-sm font-medium text-slate-900" data-id="element-2653">
                            {shipment.currentLocation}
                          </span>
                        </div>
                        <span className="text-sm font-bold text-slate-900" data-id="element-2654">
                          {shipment.progress}%
                        </span>
                      </div>
                      <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden" data-id="element-2655">
                        <div className="h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-500" style={{
                  width: `${shipment.progress}%`
                }} data-id="element-2656"></div>
                      </div>
                    </div>}

                {/* Details Grid */}
                <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-2657">
                  <div data-id="element-2658">
                    <p className="text-xs text-slate-500 mb-1" data-id="element-2659">Destination</p>
                    <p className="text-sm font-medium text-slate-900" data-id="element-2660">
                      {shipment.destination}
                    </p>
                    <p className="text-xs text-slate-600" data-id="element-2661">{shipment.address}</p>
                  </div>
                  <div data-id="element-2662">
                    <p className="text-xs text-slate-500 mb-1" data-id="element-2663">
                      Items & Weight
                    </p>
                    <p className="text-sm font-medium text-slate-900" data-id="element-2664">
                      {shipment.items} Items
                    </p>
                    <p className="text-xs text-slate-600" data-id="element-2665">
                      {shipment.weight} kg
                    </p>
                  </div>
                  <div data-id="element-2666">
                    <p className="text-xs text-slate-500 mb-1" data-id="element-2667">
                      Driver & Vehicle
                    </p>
                    <p className="text-sm font-medium text-slate-900" data-id="element-2668">
                      {shipment.driver}
                    </p>
                    <p className="text-xs text-slate-600" data-id="element-2669">{shipment.vehicle}</p>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex items-center justify-between pt-4 border-t border-slate-200" data-id="element-2670">
                  <div className="flex items-center gap-4 text-xs text-slate-600" data-id="element-2671">
                    <div className="flex items-center gap-1" data-id="element-2672">
                      <Clock className="w-3 h-3" data-id="element-2673" />
                      <span data-id="element-2674">Pickup: {shipment.pickupTime}</span>
                    </div>
                    {shipment.estimatedDelivery !== '-' && <>
                        <span className="text-slate-400" data-id="element-2675">•</span>
                        <div className="flex items-center gap-1" data-id="element-2676">
                          <Clock className="w-3 h-3" data-id="element-2677" />
                          <span data-id="element-2678">
                            Est. Delivery: {shipment.estimatedDelivery}
                          </span>
                        </div>
                      </>}
                  </div>

                  <div className="flex gap-2" data-id="element-2679">
                    {shipment.status === 'ready' && <Button variant="primary" size="sm" icon={<Truck className="w-4 h-4" data-id="element-2681" />} data-id="element-2680">
                        Assign Driver
                      </Button>}
                    {shipment.status === 'in_transit' && <>
                        <Button variant="outline" size="sm" icon={<Phone className="w-4 h-4" data-id="element-2683" />} data-id="element-2682">
                          Call Driver
                        </Button>
                        <Button variant="primary" size="sm" icon={<Navigation className="w-4 h-4" data-id="element-2685" />} data-id="element-2684">
                          Track Live
                        </Button>
                      </>}
                    {shipment.status === 'delivered' && <Button variant="outline" size="sm" icon={<CheckCircle className="w-4 h-4" data-id="element-2687" />} data-id="element-2686">
                        View POD
                      </Button>}
                  </div>
                </div>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}